import { ClockIcon, Cog8ToothIcon, PlusIcon, UsersIcon } from "@heroicons/react/24/outline"

export const UsersTab = ({
    activeTab,
    access,
    setActiveTab,
    auditClick,
    addUserClick,
    addRoleClick
}) => {

    const tabConfig = {
        users: {
            title: "User Permissions",
            description: "Manage user access and permissions across all system modules",
            buttonTitle: "Add User"
        },
        roles: {
            title: "Roles Management",
            description: "Create and manage custom roles with specific tab permissions",
            buttonTitle: "Create Role"
        }
    };
    const { title, description, buttonTitle } = tabConfig[activeTab] || {};

    return (
        <div className="bg-card">
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div className="min-w-0">
                    <div className="flex items-center justify-between gap-3">
                        <h1 className="min-w-0 flex-1 truncate whitespace-nowrap text-base font-semibold text-card-foreground md:flex-none md:text-2xl">
                            {title}
                        </h1>
                        <div className="flex items-center gap-1 rounded-md">
                            <button
                                onClick={() => setActiveTab('users')}
                                className={`inline-flex items-center justify-center whitespace-nowrap rounded-md border px-3 text-xs font-medium shadow-xs transition-all disabled:pointer-events-none disabled:opacity-50 outline-none h-8 gap-1.5 md:border-transparent ${activeTab === "users" ? "text-white bg-primary border-primary" : "border-gray-300 text-primary hover:bg-gray-200"}`}
                            >
                                <UsersIcon className="h-4 w-4" />
                                <span>Users</span>
                            </button>
                            <button
                                onClick={() => setActiveTab('roles')}
                                className={`group inline-flex items-center justify-center whitespace-nowrap rounded-md border px-3 text-xs font-medium transition-all disabled:pointer-events-none disabled:opacity-50 shrink-0 outline-none h-8 gap-2 md:border-transparent ${activeTab === "roles" ? "text-white bg-primary border-primary" : "border-gray-300 text-primary hover:bg-gray-200"}`}
                            >
                                <Cog8ToothIcon className={`h-4 w-4 ${activeTab === "roles" ? "text-white" : "text-primary group-hover:text-gray-900"}`}/>
                                <span className={`${activeTab === "roles" ? "text-white" : "text-primary group-hover:text-white"}`}>
                                    <span className="md:hidden">Roles</span>
                                    <span className="hidden md:inline">Manage Roles</span>
                                </span>
                            </button>
                            <button
                                onClick={(e) => {
                                    auditClick?.(e);
                                }}
                                className="group inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-background shadow-xs transition-all hover:bg-primary hover:text-white md:hidden"
                                aria-label="Audit Trail"
                            >
                                <ClockIcon className="h-4 w-4 text-primary group-hover:text-white" />
                            </button>
                        </div>
                    </div>
                    <p className="mt-1 hidden text-sm text-muted-foreground md:block">
                        {description}
                    </p>
                </div>
                <div className="flex flex-wrap items-center justify-end gap-2">
                    <button
                        onClick={(e) => {
                            auditClick?.(e);
                        }}
                        className="group hidden h-8 items-center justify-center whitespace-nowrap rounded-md border bg-background px-2.5 py-1.5 text-xs font-medium shadow-xs transition-all hover:bg-primary hover:text-white md:inline-flex"
                    >
                        <ClockIcon className="h-4 w-4 text-primary group-hover:text-white" />
                        <span className="hidden md:inline">Audit Trail</span>
                    </button>
                    {access === "edit" && (
                        <button
                            onClick={(e) => {
                                if (activeTab === "users") {
                                    addUserClick?.(e)
                                }
                                if (activeTab === "roles") {
                                    addRoleClick?.(e);
                                }
                            }}
                            className="hidden h-8 items-center justify-center whitespace-nowrap rounded-md bg-primary px-2.5 py-1.5 text-xs font-medium text-white shadow-xs transition-all hover:bg-gray-800 md:inline-flex"
                        >
                            <PlusIcon className="h-4 w-4 text-white"/>
                            <span className="hidden md:inline">{buttonTitle}</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}